export default __webpack_public_path__ + "static/media/cryptocurrency.043e5b21.png";